import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import { formatPrice, CarStatus, CarStatusColor, CarStatusIc, formatTitleInUrl, toggleSidebar } from "../common/common";

import { IcStarRating, IcTotalTrip, IcAddrCar } from "../common/svg";

import car_photo from "../../static/images/upload/car_1.png";

const CarItemMyCars = ({ car, id, showConfirmRemove, appInit }) => {
	const priceMode = appInit?.data?.priceMode;

	return (
		<div className="item-car row">
			<div className="item-box">
				<div className="img-car">
					<Link to={`/car/${car.sd === 0 ? "wd/" : ""}${formatTitleInUrl(car.name)}/${car.id}`}>
						<div className="fix-img">
							<img
								loading="lazy"
								src={car.photos ? car.photos[0].thumbUrl : car_photo}
								alt={`Cho thuê xe ${car.name}`}
							/>
						</div>
					</Link>
				</div>
				<div className="desc-car">
					<div className={`desc-status ${CarStatusColor[car.status]}`}>
						<div className="wrap-svg">{CarStatusIc[car.status]}</div>
						{CarStatus[car.status]}
					</div>
					<div className="desc-name">
						<p>{car.name}</p>
					</div>
					<div className="desc-info">
						{car.totalTrips > 0 ? (
							<>
								<div className="wrap-svg">
									<IcStarRating />
								</div>
								<span className="info">{car.rating.avg.toFixed(1)}</span>
								<span className="dot">•</span>
								<div className="wrap-svg">
									<IcTotalTrip />
								</div>
								<span className="info">{car.totalTrips} chuyến</span>
							</>
						) : (
							<span className="info">Chưa có chuyến</span>
						)}
					</div>
					<div className="desc-two-price">
						{priceMode === 2 ? (
							<>
								{car.sd === 1 && <p className="desc-two-price__item">Giá tự lái: {formatPrice(car.priceWithFee)}</p>}
								{car.wd === 1 && (
									<p className="desc-two-price__item">Giá có tài xế: {formatPrice(car.wdShort.priceWithFee)}</p>
								)}
							</>
						) : (
							<>
								{car.sd === 1 && <p className="desc-two-price__item">Giá tự lái: {formatPrice(car.price)}</p>}
								{car.wd === 1 && (
									<p className="desc-two-price__item">Giá có tài xế: {formatPrice(car.wdShort.price)}</p>
								)}
							</>
						)}
					</div>
					<div className="desc-address-price">
						<div className="address">
							<div className="wrap-svg">
								<IcAddrCar />
							</div>
							<p>{car.locationAddrS}</p>
						</div>
					</div>
				</div>
				<div className="profile">
					<Link className="btn btn--s btn-primary" to={`/carsetting/${car.id}#infosetting`}>
						Quản lý xe
					</Link>
					<Link
						className="btn btn--s btn-link"
						to={`/car/${car.sd === 0 ? "wd/" : ""}${formatTitleInUrl(car.name)}/${car.id}`}>
						Xem chi tiết
					</Link>
				</div>
			</div>
			{/* Delete Car 
					<a
					className="func-remove"
						onClick={() => {
							showConfirmRemove(car.id);
						}}
					>
						<i className="ic ic-remove"></i>
					</a> */}

			{/* 
					<a className={"btn btn-primary btn--m"} href={`/carsetting/${car.id}#infosetting`}>
						Quản lý xe
					</a>
			*/}
		</div>
	);
};

function mapState(state) {
	return {
		appInit: state.appInit,
	};
}

export default connect(mapState)(CarItemMyCars);
